module.exports = __webpack_public_path__ + "static/media/thank-you.6cfa6d0e.svg";